module.exports = __webpack_public_path__ + "fonts/bd86e53.ttf";